import React from "react";

export default function Chat(){
    return(
        <div className="d-flex flex-row flex-wrap">
            <div className="col-2 p-6">
                <div className="bg-white border-0 d-flex mb-7 align-items-center rounded">
                    <div className="card">
                        
                    </div>
                </div>
            </div>
            <div className="col-10 p-6">
                <div className="bg-white border-0 d-flex mb-7 align-items-center rounded">
                    
                </div>
            </div>
        </div>
    );
};